import { useState, useEffect } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from 'antd';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';

import { SearchCriteria, search } from 'store/eligibility/actions';
import { getAllDesc, getContractedIPA } from 'store/app/ipa/actions';

import SearchMemberForm from 'components/QualityOverview/SearchMemberForm';
import SearchMemberResultsTable from 'components/Eligibility/SearchMemberResultsTable';
import HelpCenterLink from 'components/Common/HelpCenterLink';

import styles from './SearchEligibility.module.scss';
import { getHelpCenterLinks } from 'store/app/helpCenter/actions';

interface SearchEligibilityPageProps {
  search(searchCriteria: SearchCriteria): any;
  getAllDesc(): any;
  getContractedIPA(userId: string): any;
  isSearchingMembers: boolean;
  getHelpCenterLinks(companyId: string, page: string, type: string): any;
}

const { Title } = Typography;

const SearchEligibilityPage = (props: SearchEligibilityPageProps) => {

  const [searchResult, setSearchResult] = useState<Object[]>([]);
  const [showTable, setShowTable] = useState(false);
  const [helpCenter, setHelpCenter] = useState<any>([]);

  useEffect(() => {
    //uses the previous search results saved in sessionStorage when going back from /eligibility/member-detail page
    if (sessionStorage.getItem('previous_location') === '/eligibility/member-detail') {
      const previousSearchResult = JSON.parse(sessionStorage.getItem('search_eligibility_result_table') || '[]');
      setShowTable(previousSearchResult.length > 0 ? true : false);
      setSearchResult(previousSearchResult);
    }

    //this is used to keep track of previous path to retain the search table results when going back to the /eligibility/search table
    sessionStorage.setItem('previous_location', '/eligibility/search');
    getHelpCenterLinks();
  }, []);

  const newTableDataHandler = (searchResult: Object[]) => {
    setShowTable(searchResult.length > 0 ? true : false);
    setSearchResult(searchResult);
    sessionStorage.setItem('search_eligibility_result_table', JSON.stringify(searchResult));
  }

  const getHelpCenterLinks = () => {
    props.getHelpCenterLinks(sessionStorage.getItem('ipaGroup')!, '/eligibility/search', 'page')
      .then((response: any) => {
        setHelpCenter(response);
    })
    .catch((err: ErrorResponse) => {
      console.log(err?.response?.data?.Message);
    });
  }

  return (
    <div className={styles['eligibility-search-page']}>
      <div className={styles["header-title"]}>
        <Title level={4} className="ml-3">Member Eligibility</Title>
      </div>
      {
          helpCenter?.length > 0 ? helpCenter.map((hc: any) => {
            return (
              <>
                <div className={`row ${styles['help-center-link']}`}>
                  <div className="col-md-24">
                    <HelpCenterLink
                      clickEventId={hc.ClickEventId}
                      linkName={hc.LinkName}
                      pagePath={hc.PagePath}
                      url={hc.Link}
                      companyId={hc.CompanyId}
                    />
                  </div>
                </div>
              </>
            );
          }) : null
        }
      <div className={styles["search-section"]}>
        <SearchMemberForm
          search={props.search}
          isSearchingMembers={props.isSearchingMembers}
          newTableDataHandler={newTableDataHandler}
          getAllDesc={props.getAllDesc}
          getContractedIPA={props.getContractedIPA}
          redirect={false}
        />
      </div>
      { showTable && (
        <div className={styles["content"]}>
          <SearchMemberResultsTable
            dataSource={searchResult}
            isSearchingMembers={props.isSearchingMembers}
          />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isSearchingMembers: store.rootReducer.eligibility.isSearchingMembers, //Search Eligibility table
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    search,
    getAllDesc,
    getContractedIPA,
    getHelpCenterLinks,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(SearchEligibilityPage);